/**
 * Deliberately SEPARATE from api/client.ts's apiClient - that client
 * has a global interceptor that hard-redirects to /auth/login on any
 * 401 (see its own comments). This client talks only to /api/public/*
 * and must NEVER trigger that redirect, since an anonymous candidate
 * browsing job listings is not a login failure.
 */
async function publicRequest<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'include', // sends the applicant-portal session cookie, if any
  });

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error((data && data.error) || `Request failed (${res.status})`);
  }
  return data as T;
}

export const publicApiClient = {
  get: <T>(path: string) => publicRequest<T>('GET', path),
  post: <T>(path: string, body?: unknown) => publicRequest<T>('POST', path, body),
  put: <T>(path: string, body?: unknown) => publicRequest<T>('PUT', path, body),
};
